import React from 'react';

interface FlowIconProps {
  className?: string;
  width?: number;
  height?: number;
}

export const FlowIcon = ({
  className,
  width = 16,
  height = 16,
}: FlowIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 216 216"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_121_635)">
      <path
        d="M0 172.08H43.0201V215.1H0V172.08ZM86.0399 86.0399H172.08V129.06H86.0399V172.08H43.0201V0H215.1V43.0201H86.0399V86.0399Z"
        fill="#1B1B18"
      />
    </g>
    <defs>
      <clipPath id="clip0_121_635">
        <rect width="215.1" height="215.1" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
